import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  field: {
    width: '50%',
    minWidth: 300,
    marginTop: 15
  }
}));
